const  GA = {
  dots:[
    '',
    '<svg width="114" height="107" viewBox="0 0 114 107" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M68.7001 107C62.8001 106.8 57.0001 105.6 51.6001 103.1C41.4001 98.5 32.2001 92.4 24.4001 84.3C16.2001 75.8 10.0001 66 5.20012 55.2C3.70012 51.9 2.40011 48.5 1.40011 45C-0.199886 39.6 1.00011 34.3 2.90011 29.2C7.20011 17.8 15.3001 10 26.3001 4.90001C33.1001 1.70001 40.2001 0.200012 47.6001 0.200012C52.7001 0.200012 57.7001 1.20002 62.6001 2.50002C70.0001 4.50002 77.5001 6.30002 84.6001 9.50002C91.2001 12.4 97.4001 15.8 102.7 20.7C108.3 25.9 111.4 32.4 112.9 39.8C114.2 46.2 113.5 52.5 112.2 58.8C110.6 66.6 108.9 74.4 106 81.8C104.1 86.7 101.5 91.3 97.9001 95.1C94.9001 98.2 91.3001 100.6 87.4001 102.4C81.5001 105.3 75.3001 106.8 68.7001 107ZM100 58.5C99.8001 55.8 99.7001 53.2 99.4001 50.5C97.8001 36.9 90.4001 27.2 78.5001 21.1C68.4001 15.9 57.5001 14.1 46.2001 14.9C36.3001 15.6 28.6001 20.5 23.2001 28.6C18.0001 36.4 18.2001 45 21.0001 53.5C23.1001 60 27.5001 65.1 32.1001 69.9C37.3001 75.4 43.1001 80.4 49.1001 85.2C52.0001 87.5 54.9001 89.8 58.5001 90.8C66.2001 92.8 73.7001 92.3 80.9001 88.8C87.8001 85.5 93.4001 80.6 97.0001 73.8C99.4001 69.1 100 63.9 100 58.5Z" fill="currentColor"/></svg>',
    '<svg width="103" height="103" viewBox="0 0 103 103" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M67.8001 101.9C64.1001 101.7 61.4001 101.4 58.7001 101.4C56.1001 101.4 53.5001 101.7 50.8001 102C46.4001 102.4 42.2001 101.7 38.0001 100.6C30.6001 98.5 24.2001 94.7 18.9001 89.3C14.2001 84.5 10.7001 79 7.50012 73.1C4.60012 67.7 2.40012 62.1 1.00012 56.1C-0.599875 49 0.600131 42.3 3.10013 35.7C5.50013 29.5 9.40013 24.3 13.6001 19.3C17.4001 14.9 21.4001 10.7 26.3001 7.40002C32.3001 3.30002 38.8001 0.800023 46.1001 0.700023C49.7001 0.600023 53.3001 1.40002 56.8001 2.20002C68.6001 5.10002 79.0001 10.8 87.4001 19.5C94.5001 26.8 99.4001 35.5 101 45.6C101.9 50.9 102.1 56.3 102.7 61.6C103.3 67.5 102.7 73.3 100.7 78.9C96.3001 91 87.9001 98.5 75.2001 101.1C72.5001 101.6 69.7001 101.7 67.8001 101.9ZM19.1001 54.9C19.0001 59.4 19.4001 63.8 20.7001 68C22.3001 73.2 25.6001 77.2 29.5001 80.9C32.5001 83.7 35.9001 85.8 39.8001 87C43.9001 88.3 48.1001 88.2 52.4001 88.2C62.0001 88.1 70.6001 85.3 77.8001 78.7C80.9001 75.8 83.7001 72.8 85.6001 69C87.5001 65.1 87.6001 61 87.7001 56.8C87.8001 52.2 86.5001 48.1 84.1001 44.2C81.0001 39 76.7001 35 72.1001 31.1C63.5001 23.8 53.5001 21.6 42.5001 23.5C32.9001 25.2 26.5001 31.4 22.0001 39.6C19.4001 44.3 18.9001 49.6 19.1001 54.9Z" fill="currentColor"/></svg>',
    '<svg width="114" height="105" viewBox="0 0 114 105" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48.4001 0C56.7001 0.2 64.7001 1.89999 72.5001 4.89999C81.8001 8.39999 90.6001 12.8 98.9001 18.3C106.1 23.2 110.8 29.8 112.7 38.4C113.2 40.9 113.3 43.4 112.9 46C112.6 48.6 112.6 51.2 112.3 53.9C111 66.5 106.5 77.7 97.9001 87.1C90.0001 95.7 80.0001 100.8 68.7001 103.3C55.9001 106.1 44.1001 103.2 32.8001 97.4C26.7001 94.3 21.1001 90.5 16.2001 85.7C8.70008 78.4 3.50006 69.6 1.30006 59.2C-1.99994 43.7 1.50008 29.6 10.7001 16.8C14.4001 11.6 19.7001 8.2 25.3001 5.5C32.5001 1.9 40.3001 0.2 48.4001 0ZM55.6 16.6C50.1 16.4 44.7 16.9 39.6 18.8C27 23.6 18.1 31.7 16.6 45.9C15.9 52.2 16.5001 58.5 19.3001 64.4C21.5001 69 24.7001 72.8 28.3001 76.3C31.9001 79.8 36.1001 82.5 40.8001 84.4C46.8001 86.8 53.1001 87.4 59.5001 87.3C68.7001 87 76.9001 84.3 83.8001 78.2C87.4001 75 90.7001 71.5 92.7001 67.1C96.1001 59.5 96.1 51.6 94.1 43.7C91.5 33.6 84.7001 26.5 76.0001 21.4C69.7001 17.5 62.7 16.2 55.6 16.6Z" fill="currentColor"/></svg>'  
  ],
  colorSwatches:function(){
    //console.log(document.querySelectorAll('.product-grid-item__swatch .swatch__label'));
    document.querySelectorAll('.ga-swatches .ga-swatch').forEach(el=>{
      if(window.gaSwatchColors[el.dataset.color]){
        el.style.color = window.gaSwatchColors[el.dataset.color];
      }else{
        el.style.color='black'
      }
        el.addEventListener('click',function(){
            console.log();
          if(el.dataset.fp){
            document.querySelector('[data-p-id="'+el.dataset.pid+'"].one-img').setAttribute('src',el.dataset.fp);  
          }
          
        });
    });
  },
  sDots:function(){
     document.querySelectorAll('.slick-dots button').forEach(el=>{
      let label = el.getAttribute('aria-label');
    
       if(label[0] == '1'){
         el.innerHTML = GA.dots[1]   
       }
       if(label[0] == '2'){
         el.innerHTML = GA.dots[2]   
       }
       if(label[0] == '3'){
         el.innerHTML = GA.dots[3]   
       }
       if(label[0] == '1'){
         el.innerHTML = GA.dots[1]   
       }
       if(label[0] == '2'){
         el.innerHTML = GA.dots[2]   
       }
       if(label[0] == '3'){
         el.innerHTML = GA.dots[3]   
       }
       if(label[0] == '1'){
         el.innerHTML = GA.dots[1]   
       }
       if(label[0] == '2'){
         el.innerHTML = GA.dots[2]   
       }
       if(label[0] == '3'){
         el.innerHTML = GA.dots[3]   
       }
     });
  },
  fDots:function(){
    document.querySelectorAll('.flickity-page-dots .dot').forEach(el=>{
      let label = el.getAttribute('aria-label');
     // console.log(el.innerHTML);
      if(label == 'Page dot 1'){
       el.innerHTML = GA.dots[1]   
      }
      if(label == 'Page dot 2'){
       el.innerHTML = GA.dots[2]   
      }
      if(label == 'Page dot 3'){
       el.innerHTML = GA.dots[3]   
      }
      if(label == 'Page dot 4'){
       el.innerHTML = GA.dots[1]   
      }
      if(label == 'Page dot 5'){
       el.innerHTML = GA.dots[2]   
      }
      if(label == 'Page dot 6'){
       el.innerHTML = GA.dots[3]   
      }
      if(label == 'Page dot 7'){
       el.innerHTML = GA.dots[1]   
      }
      if(label == 'Page dot 8'){
       el.innerHTML = GA.dots[2]   
      }
      if(label == 'Page dot 9'){
       el.innerHTML = GA.dots[3]   
      }
       if(label == 'Page dot 10'){
       el.innerHTML = GA.dots[1]   
      }
     
    })
  }
}



window.addEventListener("DOMContentLoaded", (event) => {
  GA.colorSwatches();
  setTimeout(function(){
    GA.fDots();
    GA.sDots();
      GA.colorSwatches();
  },3000);

});